import type { Editor } from "@tiptap/react";
import React from "react";

export interface RichTextEditorContextValue {
  editor: Editor | null;
  /** True when the toolbar controls should not act on the editor (e.g. while a raw view is showing). */
  disabled: boolean;
}

export const RichTextEditorContext = React.createContext<RichTextEditorContextValue>({
  editor: null,
  disabled: false,
});

/** The editor the surrounding `RichTextEditor` was given. For custom toolbar controls. */
export const useRichTextEditor = (): RichTextEditorContextValue => React.useContext(RichTextEditorContext);

/** Keeps the editor selection in place when a toolbar button is pressed. */
export const preserveSelection = (event: React.MouseEvent) => event.preventDefault();
